import qs from 'qs';
import axios from 'axios';

const HUBSPOT_PORTAL_ID = '45645086';

function getHubSpotCookie() {
  const name = 'hubspotutk=';
  const decodedCookie = decodeURIComponent(document.cookie);
  return (
    decodedCookie
      .split(';')
      .map((part) => part.trim())
      .find((part) => part.startsWith(name))
      ?.substring(name.length) || ''
  );
}

/**
 * Submit a lead form to HubSpot's legacy Forms API (same pipeline as
 * hubspotProposalCapture.js in the backyard flow). Empty values are dropped.
 * See docs/CONTACT_FORM_V2.md — Submission pipeline.
 */
export async function submitHubSpotForm(formGuid, fields) {
  const cleaned = Object.fromEntries(
    Object.entries(fields).filter(([, value]) => value != null && value !== ''),
  );

  const encodedFormData = qs.stringify({
    ...cleaned,
    hs_context: JSON.stringify({
      hutk: getHubSpotCookie(),
      pageUri: window.location.href,
      pageName: document.title,
    }),
  });

  await axios.post(
    `https://forms.hubspot.com/uploads/form/v2/${HUBSPOT_PORTAL_ID}/${formGuid}`,
    encodedFormData,
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
  );
}
